/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Coupon } from '../../models/coupon';
import { CouponHalResponse } from '../../models/coupon-hal-response';

export interface CouponsCouponIdPut$Params {
  'Active-Tenant-Identifier': string;
  couponId: string;
      body?: Coupon
}

export function couponsCouponIdPut(http: HttpClient, rootUrl: string, params: CouponsCouponIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<CouponHalResponse>> {
  const rb = new RequestBuilder(rootUrl, couponsCouponIdPut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('couponId', params.couponId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CouponHalResponse>;
    })
  );
}

couponsCouponIdPut.PATH = '/coupons/{couponId}';
